




























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ContactProperty } from '../../installation-wizard/classes/contactProperty';
import draggable from 'vuedraggable';

@Component({
  components: {
    draggable,
  },
})
export default class PropSettings extends Vue {
  @Prop() public data!: ContactProperty[];
  @Prop() public origin: string = '';

  public props!: ContactProperty[];
  public drag: boolean;
  public infoOpen: { [key: string]: boolean} = {};

  public constructor() {
    super();
    this.drag = false;
    this.props = this.data;
  }

  @Watch('data')
  public updateProps() {
    this.props = this.data;
  }

  @Watch('origin')
  public filterProps(){
    this.props = this.data.filter(n => !this.origin || n.origin === this.origin);
  }
  public created() {
    this.setupInfoOpenArray();
    this.updateProps();
  }

  get dragOptions() {
    return {
      animation: 200,
      group: 'props',
      disabled: this.origin !== '',
      ghostClass: 'ghost',
    };
  }

  public sort() {
    this.props = this.props.sort((a, b) => a.order - b.order);
  }

  public changeVisibility(propId: string) {
    const index = this.props.findIndex((item: ContactProperty) => {
      return item.propertyId === propId;
    });
    if (index > -1) {
      this.props[index].isActive = !this.props[index].isActive;
      this.updatePropsData();
    }
  }

  public onMove({ relatedContext, draggedContext }: any) {
    const relatedElement = relatedContext.element;
    const draggedElement = draggedContext.element;
    return (
      (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
    );
  }

  public afterDragging() {
    this.drag = false;
    for (let i = 1; i <= this.props.length; i++) {
      this.props[i - 1].order = i;
    }
    this.updatePropsData();
  }

  public updatePropsData() {
    this.$emit('update', this.props);
  }

  public setupInfoOpenArray() {
    for (const prop of this.data) {
      this.infoOpen[prop.propertyId] = false;
    }
  }

  public openInfo(propId: string) {
    Vue.set(this.infoOpen, propId, !this.infoOpen[propId]);
    this.$forceUpdate();
  }

  public getOriginType(origin: string|null) {
    const originMapper: any = {
      custom: null,
      pipedrive: 'warning',
      shoper: 'success',
      shopify: 'danger',
    };

    if (origin) {
      return originMapper[origin];
    } else {
      return originMapper.custom;
    }
  }
}
